import { InputProps } from 'humanity/primitives/input';

export const searchInputProps = InputProps;
